import { AxiosError } from 'axios';

import useMonolithApiMutation, { UseMonolithApiMutationOptions } from '@/hooks/api/useMonolithApiMutation';
import { QuarantineItem } from '@/pages/App/TestQuarantinePage/TestQuarantinePage.types';

export const testQuarantineItemAddPath = (projectSlug: string) => {
  return `/app/${projectSlug}/quarantine/test_case`;
};

const useTestQuarantineAdd = (
  projectSlug: string,
  options: UseMonolithApiMutationOptions<QuarantineItem, AxiosError, QuarantineItem>,
) => {
  return useMonolithApiMutation<QuarantineItem, AxiosError, QuarantineItem>(
    testQuarantineItemAddPath(projectSlug),
    'POST',
    options,
  );
};

export default useTestQuarantineAdd;
